module.exports = __webpack_public_path__ + "static/media/TopNavLogo.de639cf0.png";